import { Link } from 'react-router-dom';
import type { FichaPresenca, ConviteDivulgar, SugestaoAposPresenca } from '../types';
import { primeiroNome } from '../utils';
import CartaoConvite from './CartaoConvite';
import CartaoSugestao from './CartaoSugestao';

interface Props {
  fichas: FichaPresenca[];
  meuNome: string;
  convites: ConviteDivulgar[];
  sugestao: SugestaoAposPresenca | null;
}

function LinhaResumo({ ficha }: { ficha: FichaPresenca }) {
  if (ficha.presenca === 'confirmada') {
    return (
      <div className="flex items-center justify-between gap-4">
        <span className="text-base font-medium text-foreground-950">{ficha.nome}</span>
        <span className="flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-green-700">
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-check-line" />
          </span>
          presença confirmada
        </span>
      </div>
    );
  }

  if (ficha.presenca === 'aguardando') {
    return (
      <div className="flex items-center justify-between gap-4">
        <span className="text-base font-medium text-foreground-950">{ficha.nome}</span>
        <span className="whitespace-nowrap text-sm text-secondary-600">
          ⏳ aguardando a direção
        </span>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between gap-4">
      <span className="text-base font-medium text-foreground-950">{ficha.nome}</span>
      <span className="whitespace-nowrap text-sm text-amber-700">✗ não confirmada</span>
    </div>
  );
}

export default function TelaConclusao({ fichas, meuNome, convites, sugestao }: Props) {
  const temAguardando = fichas.some((f) => f.presenca === 'aguardando');
  const nome = meuNome ? primeiroNome(meuNome) : '';

  return (
    <div className="min-h-screen bg-background-100">
      <div className="mx-auto w-full max-w-[480px] px-4 py-10">
        <div className="text-center">
          <span className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-green-100 text-green-600">
            <i className="ri-check-line text-5xl" />
          </span>
          <h1 className="mt-5 text-2xl font-semibold text-foreground-950">
            Tudo certo{nome ? `, ${nome}` : ''}!
          </h1>
        </div>

        <div className="mt-8 rounded-xl border border-secondary-200 bg-white p-5">
          <div className="space-y-3">
            {fichas.map((f) => (
              <LinhaResumo key={f.inscricao_id} ficha={f} />
            ))}
          </div>
        </div>

        {temAguardando && (
          <p className="mt-4 text-center text-sm text-secondary-600">
            A direção vai conferir as fotos. Você não precisa fazer mais nada.
          </p>
        )}

        {sugestao && sugestao.mostrar && (
          <div className="mt-10 border-t border-secondary-200 pt-10">
            <CartaoSugestao sugestao={sugestao} />
          </div>
        )}

        {convites.length > 0 && (
          <div className="mt-10 border-t border-secondary-200 pt-10">
            {convites.map((c) => (
              <div key={c.evento_id} className="mt-6 first:mt-0">
                <p className="text-lg font-semibold text-foreground-950">{c.chamada}</p>
                <div className="mt-4">
                  <CartaoConvite convite={c} />
                </div>
              </div>
            ))}
            <Link
              to="/"
              className="mt-6 block text-center text-sm text-secondary-500 transition-colors hover:text-foreground-800"
            >
              Agora não, obrigado
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}